export default __webpack_public_path__ + "static/media/NotHappyFace.2610e79a.svg";